module.exports = __webpack_public_path__ + "assets/img/CUA-Social-Static-Ad.497abb44.png";